import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import React from 'react';
import Box from '@mui/material/Box';

// Extend props so you can override MUI's defaults
export interface LoadingProps extends CircularProgressProps {
  size?: number;
  color?: CircularProgressProps['color'];
  center?: boolean;
}

const Loading: React.FC<LoadingProps> = ({
  size = 21,
  color = 'inherit', // ✅ safer default (MUI has built-in color variants)
  center = false,
  ...restProps
}) => {
  const progress = <CircularProgress size={size} color={color} {...restProps} />;

  if (center) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100%" width="100%">
        {progress}
      </Box>
    );
  }

  return progress;
};

export default React.memo(Loading);
